import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RespuestaTokenDto } from '../dto/respuesta-token-dto';

@Injectable({
  providedIn: 'root'
})
export class VerificacionService {

  url = `${environment.host}/api/token`;

  constructor(private http: HttpClient,
    private loginService: LoginService,
    private router: Router) { }

  obtener(): Observable<RespuestaTokenDto> {
    return this.http.get<RespuestaTokenDto>(`${this.url}/obtener`);
  }

  verificar(codigo: string): Observable<RespuestaTokenDto> {
    return this.http.get<RespuestaTokenDto>(`${this.url}/validar/${codigo}`);
  }

  validarSiTieneToken(): Boolean {
    let validador = this.desifrarTok();
    let val = true;

    if (validador != null) {

      if (validador != 1) {
        this.loginService.logout(); // limpia storage y navega
        val = false;
      }

    } else {

      if (sessionStorage.getItem(environment.tokenName) == null) {
        this.loginService.logout(); // limpia storage y navega
      }
    }

    return true;
  }

  desifrarTok(): number {
    let tok = localStorage.getItem("tok") != null ? localStorage.getItem("tok") : null
    let respuesta: number = null;

    if (tok != null) {
      respuesta = Number(atob(tok).split(".")[0]);
    }

    return respuesta;
  }
}
